import { Component, EventEmitter, Input, Optional, Output } from '@angular/core';
import { ReceitaFormComponent } from '../../receita-form/receita-form.component';
import { delay, forkJoin, map, of, Subscription, switchMap, timer } from 'rxjs';
import { NotifyService } from 'src/app/shared/services/notify.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ModalService } from 'src/app/shared/services/modal.service';
import { RevenuePaymentMethodService } from 'src/app/shared/services/revenue-payment-method.service';
import { RevenueInvoiceEventService } from 'src/app/shared/services/revenue-invoice-event.service';
import { Filter } from 'src/app/shared/models/filter';
import { SplitModalService } from 'src/app/core/services/split-modal.service';
import { GenericComponent } from 'src/app/core/abstracts/generic-component';

@Component({
  selector: 'table-revenue',
  templateUrl: './table-revenue.component.html',
  styleUrls: ['./table-revenue.component.scss'],
})
export class TableRevenueComponent extends GenericComponent {
    protected listRevenue: Array<any> = [];
  
    protected loadingListRevenue: boolean = true;
  
    protected selected: any = {};
  
    protected showModalDelete: boolean = false;
    protected revenueDeleteId: any;
  
    protected totalRecords: number = 0;
    protected isDynamicDialog: boolean = false;
  
    @Input() public filter: Filter = new Filter().size(10);
    @Output() public filterChange: EventEmitter<Filter> = new EventEmitter();

    @Output() public onDeleteRevenue: EventEmitter<void> = new EventEmitter();

    @Input() public showFilter: boolean = false;

    @Input() public paginator: boolean = true;

    @Input() public theme: 'primary' | 'secondary' | 'tertiary' = "primary";
    
  
    constructor(
      public revenueInvoiceEventService: RevenueInvoiceEventService,
      public revenuePaymentMethodService: RevenuePaymentMethodService,
      public splitModalService: SplitModalService,
      private notifyService: NotifyService
    ) {
      super();
    }
  
    ngOnInit(): void {
     this.loadingInvoiceEvent();

     this.subscriptions = this.splitModalService.onClose.subscribe(() => this.loadingInvoiceEvent());
    }

    ngOnDestroy(): void {
      super.onDestroy();
    }

  
    loadingInvoiceEvent() {
      this.loadingListRevenue = true;
      this.revenueInvoiceEventService.getAll(this.filter.convertFilterInQuery())
          .pipe(
            map((response: any) => ({...response, data: this.mapRevenueInvoice(response.data)}))
          ).subscribe(
            (response: any) => {
              this.loadingListRevenue = false;
              this.listRevenue = response.data;
              console.log(this.listRevenue);
              this.totalRecords = response.total;
            }
          );
    }

    mapRevenueInvoice(revenue: any) {
      return revenue.map((r: any) => ({
        ...r,
        revenue: {
          ...r.revenue,
          isPaymentMachineOrder: r.revenue.payments.some((payment: any) => payment.orderId != null),
        }
      }))
    }
  
    pageChange(event: any) {
      this.filter.page(event.page);
      this.loadingInvoiceEvent();
    }
  
    showEditRevenue(revenueId: any) {
      this.splitModalService.calledfor('edit');
      this.splitModalService.push(ReceitaFormComponent, {
        header: 'Editar receita',
        data: {revenueId: revenueId, type: "revenue"}
      }).subscribe();
    }
  
    onFilterChange(event: any) {
      event.forEach((e: any) => {
        this.filter.setFilter(e.key, e.filter);
      });
  
      this.loadingInvoiceEvent();
    }
  
    onSearchChange(event: any) {
      this.filter.clearSearch();
      event.split(' ').map((e: any) => {
        this.filter.setSearch([
          "revenue.payer.firstName", 
          "revenue.payer.lastName",
          "revenue.payer.taxId"
        ], e);
      })
      this.loadingInvoiceEvent();
    }
  
  
    showDeleteRevenue(id: any) {
      this.showModalDelete = true;
      this.revenueDeleteId = id;
    }
  
    public fecharDialog() {
      this.showModalDelete = false;
    }
  
    handleDelete() {
      this.showModalDelete = false;
      this.revenueInvoiceEventService.delete(this.revenueDeleteId).subscribe({
          next: () => {
            this.notifyService.deleteSuccess();
            this.loadingInvoiceEvent();
            this.onDeleteRevenue.emit();
          }
       }
      )
    }
}
